import { Component } from '@angular/core';
import { User } from './auth/models';
import { AuthService } from './auth/services';
import { environment } from 'src/environments/environment';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    standalone: false
})
export class AppComponent {
  title = '';
  user: User = new User();

  constructor(private authService: AuthService) {
    this.authService.user.subscribe((x) => (this.user = x));
    if (!this.user) {
      //this.router.navigate(['/auth/login']);
    }

    if (environment.production) {
      console.log = function (): void {};
      console.debug = function (): void {};
      console.warn = function (): void {};
      console.info = function (): void {};
      console.error = function (): void {};
    }
  }

  logout() {
    this.authService.logout();
  }
}
